(function () {
	const widgets = document.querySelectorAll('.stat-donut, .stat-people, .stat-gender');

	if (!widgets.length) {
		return;
	}

	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	const canCount = typeof CountUp === 'function';

	function decimalsFor(value) {
		const parts = String(value).split('.');
		return parts[1] ? parts[1].length : 0;
	}

	function prepareCounts(widget) {
		if (!canCount) {
			return;
		}

		widget.querySelectorAll('.stat-count').forEach(function (counter) {
			const end = parseFloat(counter.getAttribute('data-count-end'));

			if (isNaN(end)) {
				return;
			}

			const decimals = decimalsFor(end);
			counter.style.minWidth = counter.offsetWidth + 'px';
			counter.textContent = decimals ? (0).toFixed(decimals) : '0';
			counter.setAttribute('data-count-decimals', String(decimals));
		});
	}

	function runCounts(widget) {
		if (!canCount) {
			return;
		}

		widget.querySelectorAll('.stat-count').forEach(function (counter) {
			const end = parseFloat(counter.getAttribute('data-count-end'));

			if (isNaN(end)) {
				return;
			}

			const decimals = parseInt(counter.getAttribute('data-count-decimals') || '0', 10);
			const countUp = new CountUp(counter, 0, end, decimals, 0.9, {
				useEasing: true,
				useGrouping: false,
			});

			if (!countUp.error) {
				countUp.start();
			}
		});
	}

	if (reduceMotion) {
		widgets.forEach(function (widget) {
			widget.classList.add('is-in-view');
		});
		return;
	}

	widgets.forEach(prepareCounts);

	function reveal(entry, observer) {
		if (!entry.isIntersecting) {
			return;
		}

		entry.target.classList.add('is-in-view');
		runCounts(entry.target);
		observer.unobserve(entry.target);
	}

	const earlyObserver = new IntersectionObserver(
		function (entries, observer) {
			entries.forEach(function (entry) {
				reveal(entry, observer);
			});
		},
		{
			threshold: 0.35,
			rootMargin: '0px 0px -8% 0px',
		},
	);

	const laterObserver = new IntersectionObserver(
		function (entries, observer) {
			entries.forEach(function (entry) {
				reveal(entry, observer);
			});
		},
		{
			threshold: 0.45,
			rootMargin: '0px 0px -16% 0px',
		},
	);

	widgets.forEach(function (widget) {
		if (widget.classList.contains('stat-gender')) {
			laterObserver.observe(widget);
			return;
		}

		earlyObserver.observe(widget);
	});
})();
